import { getCountryConfig } from '@/shared/countryConfig'
import { browserEnvs } from '@/shared/envs'

export const getApiUrl = (endpointPath: string) => {
  return !process.env.STORYBOOK
    ? `${getCountryConfig(browserEnvs.NEXT_PUBLIC_COUNTRY).basePath}/api/${endpointPath}`
    : ''
}
